import React, { useState } from "react";
import styled from "styled-components";
import { Icon, SVG } from "../../typo-components";
import { Styles } from "../../config";

const _getButtonSize = ({ size }) => {
  const px = size ? Styles.IconSize[size] : Styles.IconSize.medium;

  return `${Number(px?.replace("px", "")) + 15}px`;
};

const Vessel = styled.button.withConfig({
  shouldForwardProp: (prop) => !['iconConfig', 'icon', 'margin', 'color'].includes(prop),
})`
  position: relative;
  display: flex;

  align-items: center;
  justify-content: center;
  background: transparent;
  color: $color-secondary;
  border-radius: 999px;
  transition: all 300ms;
  padding: ${(props) => props?.style?.padding || "5px"};
  max-width: ${(props) => props?.style?.width || _getButtonSize({ size: props.iconConfig?.size })};
  max-height: ${(props) => props?.style?.height || _getButtonSize({ size: props.iconConfig?.size })};
  min-width: ${(props) => props?.style?.width || _getButtonSize({ size: props.iconConfig?.size })};
  min-height: ${(props) => props?.style?.height || _getButtonSize({ size: props.iconConfig?.size })};
  margin: ${(props) => props.margin || "0"};
  color: ${(props) =>
    props?.color ? Styles.Color[props.color] : Styles.Color.tertiary};
  cursor: pointer;

  &:not([disabled]):hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.16);
  }

  &:disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed !important;
  }
`;

const Button = (props) => {
  const { type, iconConfig, color, margin, id, disabled, style, form, icon } = props;
  const { onClick } = props;

  return (
    <Vessel
      id={id || null}
      form={form || null}
      type={type || "button"}
      onClick={!type || type === "button" ? onClick : null}
      disabled={disabled}
      style={style}
      margin={margin}
      iconConfig={iconConfig}
      icon={icon}
    >
      {icon && icon}
      {!icon && (
        <>
          {iconConfig?.type === "svg" ? (
            <SVG
              name={iconConfig.name}
              color={color}
              size={iconConfig.size || "medium"}
            ></SVG>
          ) : (
            <Icon
              name={iconConfig.name}
              color={color}
              size={iconConfig.size || "medium"}
              variant={iconConfig?.variant || ""}
            ></Icon>
          )}
        </>
      )}
    </Vessel>
  );
};

export default Button;
